export const LOCATION_UPDATE_EVENT = "LOCATION_UPDATE";
